import {ThemeType} from '../../../theme';
import {BaseBorderPxProps} from '../../base/types';
import {ThemeBorderPxProps} from '../../types';

export const mapBorderToBaseProperties = (
  theme: ThemeType,
  {
    borderColor,
    borderRadius,
    borderWidth,
    borderStyle,
    borderBottomColor,
    borderBottomLeftRadius,
    borderBottomRadius,
    borderBottomRightRadius,
    borderBottomWidth,
    borderBottomStyle,
    borderLeftColor,
    borderLeftRadius,
    borderLeftWidth,
    borderLeftStyle,
    borderRightColor,
    borderRightRadius,
    borderRightWidth,
    borderRightStyle,
    borderTopColor,
    borderTopLeftRadius,
    borderTopRadius,
    borderTopRightRadius,
    borderTopWidth,
    borderTopStyle,
    borderPosition,
  }: ThemeBorderPxProps,
): BaseBorderPxProps => ({
  borderColor: borderColor ? theme.colors[borderColor] : undefined,
  borderRadius: borderRadius ? theme.radii[borderRadius] : undefined,
  borderWidth: borderWidth ? theme.borders[borderWidth] : undefined,
  borderBottomColor: borderBottomColor
    ? theme.colors[borderBottomColor]
    : undefined,
  borderBottomLeftRadius: borderBottomLeftRadius
    ? theme.radii[borderBottomLeftRadius]
    : undefined,
  borderBottomRightRadius: borderBottomRightRadius
    ? theme.radii[borderBottomRightRadius]
    : undefined,
  borderBottomWidth: borderBottomWidth
    ? theme.borders[borderBottomWidth]
    : undefined,
  borderLeftColor: borderLeftColor ? theme.colors[borderLeftColor] : undefined,
  borderLeftWidth: borderLeftWidth ? theme.borders[borderLeftWidth] : undefined,
  borderRightColor: borderRightColor
    ? theme.colors[borderRightColor]
    : undefined,
  borderRightWidth: borderRightWidth
    ? theme.borders[borderRightWidth]
    : undefined,
  borderTopColor: borderTopColor ? theme.colors[borderTopColor] : undefined,
  borderTopLeftRadius: borderTopLeftRadius
    ? theme.radii[borderTopLeftRadius]
    : undefined,
  borderTopRightRadius: borderTopRightRadius
    ? theme.radii[borderTopRightRadius]
    : undefined,
  borderTopWidth: borderTopWidth ? theme.borders[borderTopWidth] : undefined,
  ...(borderLeftRadius
    ? {
        borderTopLeftRadius: borderLeftRadius
          ? theme.radii[borderLeftRadius]
          : undefined,
        borderBottomLeftRadius: borderLeftRadius
          ? theme.radii[borderLeftRadius]
          : undefined,
      }
    : {}),
  ...(borderBottomRadius
    ? {
        borderBottomLeftRadius: borderBottomRadius
          ? theme.radii[borderBottomRadius]
          : undefined,
        borderBottomRightRadius: borderBottomRadius
          ? theme.radii[borderBottomRadius]
          : undefined,
      }
    : {}),
  ...(borderTopRadius
    ? {
        borderTopLeftRadius: borderTopRadius
          ? theme.radii[borderTopRadius]
          : undefined,
        borderTopRightRadius: borderTopRadius
          ? theme.radii[borderTopRadius]
          : undefined,
      }
    : {}),
  ...(borderRightRadius
    ? {
        borderBottomRightRadius: borderRightRadius
          ? theme.radii[borderRightRadius]
          : undefined,
        borderTopRightRadius: borderRightRadius
          ? theme.radii[borderRightRadius]
          : undefined,
      }
    : {}),
  borderStyle,
  borderTopStyle,
  borderBottomStyle,
  borderRightStyle,
  borderLeftStyle,
  borderPosition,
});
